import { Container } from "@mui/material";
import React from "react";
import Slider from "react-infinite-logo-slider";

import "./homePage.scss";

export default function OurClients() {
  return (
    <div className="our-clients-container">
      <p className="o-c-header">
        Our <span style={{ color: "#e96c4c" }}>Clients</span>
      </p>
      <div className="o-c-lists-container">
        <Container maxWidth="lg">
          <div className="o-c-lists">
            <Slider
              className="slider"
              width="200px"
              duration={40}
              pauseOnHover={true}
              blurBorders={false}
              blurBoderColor={"#fff"}
            >
              <Slider.Slide>
                <img
                  src="https://d5r8zwzwkh326.cloudfront.net/new+ui+images/home+page/clients-logo/Sony-logo.png"
                  alt="Sony"
                  className="w-36"
                />
              </Slider.Slide>
              <Slider.Slide>
                <img
                  src="https://d5r8zwzwkh326.cloudfront.net/new+ui+images/home+page/clients-logo/Stanza_Logo.svg.png"
                  alt="Stanza Living"
                  className="w-36"
                />
              </Slider.Slide>
              <Slider.Slide>
                <img
                  src="https://d5r8zwzwkh326.cloudfront.net/new+ui+images/home+page/clients-logo/aquatein.png"
                  alt="Aquatein"
                  className="w-36"
                />
              </Slider.Slide>
              <Slider.Slide>
                <img
                  src="https://d5r8zwzwkh326.cloudfront.net/new+ui+images/home+page/clients-logo/branding_logo.png"
                  alt="Branding"
                  className="w-36"
                />
              </Slider.Slide>
              <Slider.Slide>
                <img
                  src="https://d5r8zwzwkh326.cloudfront.net/new+ui+images/home+page/clients-logo/hypen.png"
                  alt="Hypen"
                  className="w-36"
                />
              </Slider.Slide>
              <Slider.Slide>
                <img
                  src="https://d5r8zwzwkh326.cloudfront.net/new+ui+images/home+page/clients-logo/logo.png"
                  alt="Your Space"
                  className="w-36"
                />
              </Slider.Slide>
              <Slider.Slide>
                <img
                  src="https://d5r8zwzwkh326.cloudfront.net/new+ui+images/home+page/clients-logo/nsrcel.png"
                  alt="nsrcel"
                  className="w-36"
                />
              </Slider.Slide>
              <Slider.Slide>
                <img
                  src="https://d5r8zwzwkh326.cloudfront.net/new+ui+images/home+page/clients-logo/papacream.png"
                  alt="Papacream"
                  className="w-36"
                />
              </Slider.Slide>
              <Slider.Slide>
                <img
                  src="https://d5r8zwzwkh326.cloudfront.net/new+ui+images/home+page/clients-logo/shakaharifood.png"
                  alt="Shakahari Food"
                  className="w-36"
                />
              </Slider.Slide>
            </Slider>
          </div>
        </Container>
      </div>
    </div>
  );
}
